module.exports = __webpack_public_path__ + "static/img/library.88f00f3b.png";